// eslint-disable-next-line no-unused-expressions
import('./bootstrap');
